import { getReplacedString } from '../../../../../../../../../../../helpers/getReplacedString';
import { sortData } from '../../../../../../../../../utils/sortData';

const hasValues = (values) => Array.isArray(values) && values.length;

const createFilterSets = ({ filteredInfo, dataSource }) => {
  let hasFilters = false;

  const sets = Object.values(filteredInfo).reduce((acc, values) => {
    let data = new Set();

    if (hasValues(values)) {
      hasFilters = true;

      values.forEach((value) => {
        if (data.size) {
          dataSource[value].forEach((item) => data.add(item));
        } else {
          data = new Set(dataSource[value]);
        }
      });
    }

    if (data.size) {
      acc.push(data);
    }

    return acc;
  }, []);

  return { hasFilters, sets };
};

const intersectSets = (sets) => {
  if (sets.length === 0) return new Set();

  if (sets.length === 1) return sets[0];

  return sets.reduce((intersection, currentSet) => {
    const result = new Set();

    for (const item of intersection) {
      if (currentSet.has(item)) {
        result.add(item);
      }
    }

    return result;
  });
};

export const filterData = ({ dataSource, filteredInfo }) => {
  let data = dataSource['Все'];

  if (filteredInfo) {
    const { hasFilters, sets } = createFilterSets({
      filteredInfo,
      dataSource,
    });

    if (hasFilters) {
      data = intersectSets(sets);
    }
  }

  return data;
};

export const filterDataBySearch = ({ data, search }) =>
  Array.from(data).filter((item) => {
    const { address, flat } = item;

    const targetVal = getReplacedString(address?.name || flat);

    const targetValDdy = getReplacedString(address?.addressDdu || '');

    const searchVal = getReplacedString(search);

    return targetVal.includes(searchVal) || targetValDdy.includes(searchVal);
  });

export const createSortedData = ({ data, sortedInfo, columnKeys }) => {
  const { columnKey, order } = sortedInfo;

  return data
    .slice()
    .sort((a, b) => sortData(order, columnKeys[columnKey], a, b));
};
